const getColumnsCount = (file) => {
  if (!file.FieldsTypes?.length) return 0;

  return file.FieldsTypes.length;
};

export default getColumnsCount;
